import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import { connect } from 'react-redux'
import React from 'react'
import { Select } from 'antd'
import { Editor as TinyEditor } from '@tinymce/tinymce-react'
import { API_KEY, TOOLBAR } from 'constant/tinymce'
import PropTypes from 'prop-types'
import Loader from '../loader'

const { Option } = Select

class Editor extends React.Component {
  state = {
    content: null
  }

  componentDidMount = () => {
    const { description } = this.props
    this.setState({
      content: description
    })
  }

  handleChange = (value, key) => {
    const { form } = this.props
    this.setState({
      content: value
    })
    if (key.key) {
      form.setFieldsValue({ [FIELD_NAME.TEMPLATE_UUID]: key.key })
    }
    form.setFieldsValue({ [FIELD_NAME.DESCRIPTION_META]: value })
  }

  checkDescription = (description, form) => {
    if (description) {
      form.setFieldsValue({ [FIELD_NAME.DESCRIPTION_META]: description })
    }
  }

  render = () => {
    const { description, loading, templates, insight, form } = this.props
    const { content } = this.state

    this.checkDescription(description, form)

    if (loading) {
      return <Loader relative />
    }

    return (
      <>
        {templates &&
          getTemplateDropdown(templates, this.handleChange, insight)}
        <TinyEditor
          apiKey={API_KEY}
          className={'editor'}
          init={{ ...TOOLBAR }}
          onEditorChange={this.handleChange}
          value={content || description}
        />
        <p>
          <sup>*</sup> To insert a qliksense object use [iframe URL_HERE]
        </p>
      </>
    )
  }
}

const getTemplateDropdown = (templates, handleChange, insight) => (
  <div className='pb-2'>
    <span className='font-12'>{FIELD_LABEL.TEMPLATES}</span>
    <Select
      bordered={false}
      className='w-100'
      defaultValue={insight?.template_uuid ? insight.template_name : null}
      onChange={(e, key) => handleChange(e, key)}
      placeholder={'Template'}
      showSearch={false}
      size='large'
      style={{ background: '#fff' }}
    >
      {templates.map(({ name, uuid, html }) => (
        <Option
          key={uuid}
          value={html}
        >
          {name}
        </Option>
      ))}
    </Select>
  </div>
)

Editor.propTypes = {
  description: PropTypes.string,
  form: PropTypes.object,
  insight: PropTypes.object,
  loading: PropTypes.bool,
  templates: PropTypes.array
}

const mapStateToProps = (state) => ({
  description: state.article.articleDescription,
  loading: state.loader.loadingArticleDescription,
  templates: state.article.templates
})

export default connect(mapStateToProps)(Editor)
